import { createContext, useContext } from 'react'
import { getTheme } from './themeRegistry'

const ThemeContext = createContext()

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  // Always use immersive theme - it's the only theme now
  const themeId = 'immersive'
  const currentTheme = getTheme()

  return (
    <ThemeContext.Provider value={{ 
      theme: themeId,
      themeId,
      currentTheme,
    }}>
      {children}
    </ThemeContext.Provider>
  )
}
